'use client';
import { Divider as SharedDivider } from '@launchstore/shared-puck';
import type { DividerProps } from '@launchstore/shared-puck';
export const Divider: any = SharedDivider;
export type { DividerProps };
export default Divider;
